import { QueryParser } from './query-parser';

export class HttpHelper {

  getAllParamsWithFilter(filter = [] as string[]): { [key: string]: string } {
    return QueryParser.getAllParamsWithFilter(filter);
  }

  getParamValueQueryString(paramName: string): string | undefined {
    return QueryParser.getParamValueQueryString(paramName);
  }
}